export enum EventModelStatus {
  Planning,
  Submitted,
  Approved,
  Live,
  Complete,
  Closed,
}
